<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
  <path fill="#CF493C" fill-rule="evenodd" d="M7.05.9a1.062 1.062 0 0 1 1.9 0l6.46 12.922c.501 1-.227 2.178-1.346 2.178H1.935A1.505 1.505 0 0 1 .59 13.822L7.05.9zM7 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V6zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" clip-rule="evenodd"/>
</svg>
</template>